<main>
  <div>
    <p>{{title}}</p>
  </div>
  <div>
    <mat-form-field>
      <input #textInput matInput>
    </mat-form-field>
  </div>
  <div class="buttonContainer">
    <button mat-raised-button color="primary" (click)="setValue(textInput)"> Valider </button>
    <button mat-raised-button color="warn" mat-dialog-close>Annuler</button>
  </div>
</main>
